import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ZonesListComponent } from './zones-list/zones-list.component';
import { ZonesDetailComponent } from './zones-detail/zones-detail.component';

const routes: Routes = [
    {
        path: 'zones',
        children: [
            { path: '', component: ZonesListComponent }
        ]
    },
    {
        path: 'zones/:id',
        children: [
            { path: '', component: ZonesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ZonesRoutingModule { }
